import React, { Fragment } from "react";
import Moment from "react-moment";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import DataTable from "../Common/DataTable/DataTable";
import { SectionHeading, LabelText, ValueText } from "../Common/Typography/AppTypography";

const OnboardedHistory = ({ onBoardedHistoryData, showHeader = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Fragment>
      {onBoardedHistoryData && onBoardedHistoryData.length > 0 ? (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: { xs: 1.5, sm: 2 } }}>
              <SectionHeading>
                Device Onboarding / Offboarding History
              </SectionHeading>
            </Box>
          )}

          {isMobile ? (
            <Box sx={{ px: 1, pb: 1.5 }}>
              {onBoardedHistoryData.map((historyList, i) => (
                <Box
                  key={i}
                  sx={{
                    p: 1.5,
                    mb: 1,
                    bgcolor: i % 2 === 0 ? "rgba(0,0,0,0.02)" : "transparent",
                    border: "1px solid rgba(0,0,0,0.08)",
                    borderRadius: 1,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5, gap: 1, minWidth: 0 }}>
                    <LabelText sx={{ color: "primary.main", flexShrink: 0 }}>User ID</LabelText>
                    <ValueText sx={{ fontSize: "0.6rem", whiteSpace: "nowrap", overflowX: "auto", minWidth: 0, flex: 1, textAlign: "right" }}>
                      {historyList.userId}
                    </ValueText>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 0.5, gap: 1 }}>
                    <LabelText sx={{ color: "primary.main", flexShrink: 0 }}>Time Stamp</LabelText>
                    <ValueText sx={{ fontSize: "0.7rem", textAlign: "right" }}>
                      <Moment format="MMM D YYYY, h:mm a" date={historyList.ts * 1000} />
                    </ValueText>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                    <LabelText sx={{ color: "primary.main", flexShrink: 0 }}>Activity</LabelText>
                    <ValueText sx={{ fontSize: "0.7rem", textAlign: "right" }}>
                      {historyList.activity}
                    </ValueText>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ mx: 2, mb: 2 }}>
              <DataTable
                columns={[
                  { key: "userId", label: "User ID", minWidth: 160 },
                  { key: "ts", label: "Time Stamp", minWidth: 220, render: (val) => <Moment format="MMMM Do YYYY, h:mm:ss a" date={val * 1000} /> },
                  { key: "activity", label: "Activity", minWidth: 160 },
                ]}
                data={onBoardedHistoryData}
                rowKey="ts"
                minWidth="400px"
                sx={{ border: "1px solid rgba(0,0,0,0.12)", borderRadius: 1 }}
              />
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: { xs: 1.5, sm: 2 } }}>
              <SectionHeading>
                Device Onboarding / Offboarding History
              </SectionHeading>
            </Box>
          )}
          <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
            <Box sx={{ py: 1.5, px: 2, bgcolor: onBoardedHistoryData?.msg ? "rgba(211, 47, 47, 0.08)" : "rgba(0,0,0,0.04)", borderRadius: 1 }}>
              <ValueText color={onBoardedHistoryData?.msg ? "error" : "text.secondary"}>
                {(onBoardedHistoryData && onBoardedHistoryData.msg) || "No history found"}
              </ValueText>
            </Box>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};


export default OnboardedHistory;
